/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      AssistanceReplies: '$MHF_ModelNameVal_$MHF|AssistanceReplies',

};
